import { api } from "@/shared/api";

// local-only: 1010 客服 H5 端一期补完契约 2(docs/2026-10-10-客服H5端/任务书-一期补完.md),codegen 尚未覆盖。
export type KefuPendingKind = "waiting_human" | "lead";

export type KefuPendingItem = {
  sessionId: string;
  channel: string;
  entryName?: string | null;
  customerName: string;
  lastMessage: string;
  at: string;
  kind: KefuPendingKind;
};

export type KefuPending = {
  /** human_handling 且 assignee 为空的会话数 */
  waitingHuman: number;
  /** human_handling 且 assignee = 我 */
  myActive: number;
  /** 最早一条等待会话的 last_message_at */
  oldestWaitingSince?: string | null;
  /** 近 24h web 留资数 */
  newLeads24h: number;
  /** 最多 10 条,倒序 */
  latest: KefuPendingItem[];
};

export const kefuPendingService = {
  get: () => api.get<KefuPending>("/tenant/customer-service/pending"),
};
